import React from 'react';
import { Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import type { TGuaranteesAccountOption } from '../../../rootSection/types.ts';
import { formatGuaranteesSummaryValue } from '../../../utils/display/utils.ts';

interface IAccountTableRowProps {
  isDisabled: boolean;
  isSelected: boolean;
  option: TGuaranteesAccountOption;
  onAccountSelect: (option: TGuaranteesAccountOption) => void;
}

const AccountTableRow: React.FC<IAccountTableRowProps> = ({
  isDisabled,
  isSelected,
  option,
  onAccountSelect,
}) => (
  <TableRow
    hover
    onClick={() => {
      if (!isDisabled) {
        onAccountSelect(option);
      }
    }}
    sx={guaranteesClientPageStyles.flowSelectableTableRow(isSelected)}
  >
    <TableCell sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'name')}>
      <Typography sx={guaranteesClientPageStyles.flowOptionTitle}>{option.iban}</Typography>
    </TableCell>
    <TableCell align="center" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'status')}>
      {formatGuaranteesSummaryValue(option.frozen)}
    </TableCell>
    <TableCell align="center" sx={(theme) => dataFormStyles.documentTableBodyCell(theme, 'actions')}>
      <Checkbox
        checked={isSelected}
        disabled={isDisabled}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={() => {
          if (!isDisabled) {
            onAccountSelect(option);
          }
        }}
      />
    </TableCell>
  </TableRow>
);

export default AccountTableRow;
